import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { main, light } = theme.palette.primary;

  return {
    summary: {
      minHeight: 54,
      borderBottom: `1px solid ${light}`,
      "&.mobileExpandedView": {
        paddingBottom: 10
      },
      "&.Mui-expanded": {
        minHeight: 54
      },
      "& .MuiAccordionSummary-content": {
        marginTop: 16
      }
    },
    sumRoot: {
      padding: "0px 22px"
    },
    sumRootExpanded: {
      marginBottom: "0 !important"
    },
    title: {
      display: "flex",
      fontSize: 16,
      color: main,
      marginRight: 14,
      whiteSpace: "nowrap"
    },
    markAll: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: 37,
      height: 20,
      borderRadius: 39,
      backgroundColor: main,
      color: theme.palette.common.white
    },
    previewWrap: {
      whiteSpace: "nowrap",
      display: "flex",
      "&.mobileExpandedView": {
        flexWrap: "wrap"
      }
    },
    previewItem: {
      display: "inline-block",
      height: "20px",
      border: `1px solid ${main}`,
      color: main,
      padding: "1px 6px",
      textTransform: "capitalize",
      borderRadius: 39,
      marginRight: 4,
      fontSize: 12,
      marginBottom: 8,
      "&.croppedPreviewItem": {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    },
    nMore: {
      fontSize: 12,
      color: main,
      marginLeft: 4,
      display: "flex",
      height: 20,
      alignItems: "center"
    }
  };
});
